import { faHistory } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { OverlayTrigger, Popover } from 'react-bootstrap';

import './nikke-element.scss';

interface IProps {
  type: string;
  cooldown?: string;
  withcooldown?: boolean;
}

export const NikkeType: React.FC<IProps> = ({
  type,
  cooldown,
  withcooldown
}) => {
  const popoverType = (
    <Popover id="popover-type">
      <Popover.Header as="h3">
        {type === 'red' && <>Burst I-III</>}
        {type === '1' && <>Burst I</>}
        {type === '2' && <>Burst II</>}
        {type === '3' && <>Burst III</>}
        {type === 'Unknown' && (
          <>
            <span>{type}</span>
          </>
        )}
      </Popover.Header>
      <Popover.Body>
        {type === 'red' && <>A Burst I-III character/</>}
        {type === '1' && <>A Burst Type I character.</>}
        {type === '2' && <>A Burst Type II character.</>}
        {type === '3' && <>A Burst Type III character.</>}
        {type === 'Unknown' && <>{type}</>}
      </Popover.Body>
    </Popover>
  );
  return (
    <OverlayTrigger
      trigger="click"
      rootClose
      placement="auto-start"
      overlay={popoverType}
    >
      <div className={`nikke-type type-${type}`}>
        {type === 'red' && <span>Burst I-III</span>}
        {type === '1' && <span>Burst I</span>}
        {type === '2' && <span>Burst II</span>}
        {type === '3' && <span>Burst III</span>}{' '}
        {withcooldown && (
          <span className="with-cooldown">
            - <FontAwesomeIcon icon={faHistory} width="18" /> {cooldown}
          </span>
        )}
        {type === 'Unknown' && (
          <>
            <span>{type}</span>
          </>
        )}
      </div>
    </OverlayTrigger>
  );
};
